import {
  AfterViewInit,
  ComponentRef,
  Directive,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
  ViewContainerRef,
} from '@angular/core';
import { ProgressSpinnerComponent } from 'src/app/shared/components/progress-spinner/progress-spinner.component';

@Directive({
  selector: 'button[profetProgressButton]',
  standalone: true,
})
export class ProgressButtonDirective implements AfterViewInit, OnChanges {
  componentRef!: ComponentRef<ProgressSpinnerComponent>;
  host: HTMLElement;
  newProgressElement!: HTMLElement;
  btnWrapper!: HTMLElement | null;

  @Input('profetProgressButton') pmxBtnProgress: boolean = false;

  constructor(
    private _element: ElementRef,
    private _viewContainerRef: ViewContainerRef
  ) {
    this.host = this._element.nativeElement;
  }

  ngAfterViewInit(): void {
    this.btnWrapper = this.host.querySelector('.mdc-button__label');
    this.updateLoaderState(this.pmxBtnProgress);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.updateLoaderState(changes['pmxBtnProgress'].currentValue);
  }

  updateLoaderState(inProgress: boolean) {
    if (inProgress && this.btnWrapper) {
      this.componentRef = this._viewContainerRef.createComponent(ProgressSpinnerComponent);
      this.componentRef.instance.size = 20;
      this.componentRef.instance.transparency = 0;
      this.newProgressElement = this.componentRef?.location.nativeElement;
      this.host.setAttribute('disabled', '');
      this.host.insertBefore(this.newProgressElement, this.host.firstChild);
    } else if (!inProgress && this.newProgressElement && this.btnWrapper) {
      this.componentRef?.destroy();
      this.host.removeAttribute('disabled');
    }
  }
}
